import { ENROLLMENT_COMMON_MESSAGES } from '../../../../constants/enrollmentContent'
import type { NavigateFn } from '../../types'
import { SELF_ENROLLMENT_STEPS } from '../../utils/steps'

type ValidateStepContinuationOptions = {
  setInlineError?: boolean
  keepLoadingOnSuccess?: boolean
}

type ValidateStepContinuationArgs = {
  step: number
  totalSteps: number
  enrollmentSessionToken: string | null
  navigate: NavigateFn
  setStepSubmissionError: (value: string | null) => void
  setStepValidationError: (value: string | null) => void
  setIsCheckingStepAccess: (value: boolean) => void
  options?: ValidateStepContinuationOptions
}

export function validateStepContinuation({
  step,
  totalSteps,
  enrollmentSessionToken,
  navigate,
  setStepSubmissionError,
  setStepValidationError,
  setIsCheckingStepAccess,
  options
}: ValidateStepContinuationArgs) {
  if (step <= SELF_ENROLLMENT_STEPS.LOGIN || step >= totalSteps) {
    setStepValidationError(null)
    if (options?.setInlineError) {
      setStepSubmissionError(null)
    }
    return true
  }

  if (!enrollmentSessionToken) {
    const sessionExpiredMessage = ENROLLMENT_COMMON_MESSAGES.sessionExpired

    if (options?.setInlineError) {
      setStepSubmissionError(sessionExpiredMessage)
    } else {
      setStepValidationError(sessionExpiredMessage)
    }

    navigate('/application', { replace: true })
    return false
  }

  setStepValidationError(null)

  if (options?.setInlineError) {
    setStepSubmissionError(null)
  }

  if (options?.keepLoadingOnSuccess) {
    setIsCheckingStepAccess(true)
  }

  return true
}

export type { ValidateStepContinuationOptions }
